import React from "react";
import PropTypes from "prop-types";

export default class Error extends React.Component{
    render(){
        return(
            <div className="container-fluid">
                {/*<div className="row justify-content-center">
                    <img className="h-100 w-25 p-3" src="/images/sad-beaker.svg" />
                </div>*/}
                <div className="row justify-content-center">
                    <h2>{this.props.title}</h2>
                </div>
                <div className="row justify-content-center">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

Error.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.array
};
